import React, { useEffect } from 'react';
import { useMachine } from '@xstate/react';
import { createMachine } from 'xstate';

import { actions } from './actions';
import { MACHINE_CONFIG } from './config';
import { services } from './services';

export let sendOTPMachine: any;

export const useSMSendOTP = (_context: any) => {
  let _machineConfig: any = MACHINE_CONFIG;
  if (_machineConfig && _machineConfig?.context) {
    _machineConfig.context = {
      ..._machineConfig.context,
      ...(_context || {}),
    };
  }
  sendOTPMachine = createMachine(_machineConfig, {
    services,
    actions,
  });
  const [state, send] = useMachine(sendOTPMachine);

  // useEffect(() => {
  //   send({ type: 'START' });
  // }, []);

  return {
    sendOTPMachine,
    sendOTPState: state,
    sendOTPSend: send,
  };
};
